// extracted by mini-css-extract-plugin
export default {"container":"sr-z","brandName":"tr-z","productName":"ur-z","productNamePdpEnhancements":"vr-z","breakLongProductName":"wr-z"};